module.exports = __webpack_public_path__ + "static/media/Image 23 1 (1).ee082576.png";